import styled, { css } from 'styled-components';

import { Button, Typography } from '@speeki/global-ui-components';

export const DownloadPdfButton = styled(Button)`
    margin: 0 0 48px;
    min-width: auto;
`;

export const FilePasswordWrapper = styled.div(
    ({ theme: { palette, radius } }) => css`
        background-color: ${palette.tertiary.background};
        border-radius: ${radius[8]}px;
        margin-bottom: 8px;
        max-width: 556px;
        padding: 10px 54px 0;
        width: 100%;
    `,
);

export const FilePasswordInfo = styled(Typography.TextBody_16_24)(
    ({ theme: { palette } }) => css`
        border-bottom: 1px solid ${palette.neutral.white};
        padding: 12px 0;
        text-align: center;
    `,
);

export const FilePasswordText = styled(Typography.TextH3_24_34)`
    padding: 24px 0;
    text-align: center;
`;

export const FilePasswordProtectInfo = styled(Typography.TextBody_12_20)`
    margin: 0;
`;
